import * as HttpService from "../../../../service/HttpService";

/**
 * 根据户型名称模糊查询
 */
export const queryHouseSettingList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/selectHouseList",params);
};
/**
 * 根据ID精确查询
 */
export const queryHouseListById = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/selectHouseListById",params);
};

/**
 * 新增户型设置
 */
export const addHouseSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/addHouseSetting",params);
};

/**
 * 修改户型设置
 */
export const updateHouseSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/updateHouseSetting",params);
};

/**
 * 删除户型设置
 */
export const deleteHouseSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/deleteHouseSetting",params);
};
/**
 * 查询删除关联信息
 */
export const selectEnergy = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/houseSetting/selectEnergy",params);
};
